export const COLORS = ['#FFAA25', '#00B749', '#FA0067']